<template>
  <v-tooltip v-if="urgencia" bottom>
     <template v-slot:activator="{ on }">
       <v-icon v-on="on" :class="`icon ${textColorClass}`">
         {{ icon }}
       </v-icon>
     </template>
     <span>{{ description }}</span>
   </v-tooltip>
</template>

<script>
import { UrgenciaRequisicao } from 'px-business-components';

const TEXT_COLOR_MAP = {
  BAIXA: {
    color: 'green--text text--darken-3',
    icon: 'mdi-clock',
  },
  MEDIA: {
    color: 'blue--text text--darken-3',
    icon: 'mdi-clock',
  },
  ALTA: {
    color: 'yellow--text text--darken-3',
    icon: 'mdi-clock-alert',
  },
  MUITO_ALTA: {
    color: 'error--text',
    icon: 'mdi-clock-alert',
  },
};

export default {
  props: {
    urgencia: String,
  },
  computed: {
    description() {
      if (!this.urgencia) {
        return '';
      }
      return UrgenciaRequisicao.keys[this.urgencia].description;
    },
    textColorClass() {
      return TEXT_COLOR_MAP[this.urgencia].color;
    },
    icon() {
      return TEXT_COLOR_MAP[this.urgencia].icon;
    },
  },
};
</script>
<style scoped>
.icon {
  font-size: 20px;
}
</style>
